var map = {
	"./decidim/cc-by-sa--inv.svg": 34607,
	"./decidim/cc-by-sa.svg": 80656,
	"./decidim/decidim-logo-mobile--inv.svg": 33700,
	"./decidim/decidim-logo-mobile.svg": 46469,
	"./decidim/logo-kopia.png": 60456,
	"./decidim/logo.png": 74127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71027;